import React, { FC, useEffect, useState } from 'react';
import { TableRow, Checkbox, Theme, IconButton } from '@material-ui/core';
import HeaderCell from './HeaderCell';
import { makeStyles } from '@material-ui/styles';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxOutlinedUncompletedIcon from '@material-ui/icons/IndeterminateCheckBox';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

interface Header {
  label: string;
  value?: string;
  pT?: string;
  pR?: string;
  pB?: string;
  pL?: string;
  bB?: boolean;
  mW?: string;
  verticalAlign?: 'top' | 'middle' | 'bottom';
  isCheckBox?: boolean;
  isSort?: boolean;
  checked?: number[];
  rowsPerPage?: number;
  handleCheckAll?: () => void;
  orderBy?: 'asc' | 'desc';
}

interface Props {
  headers: Header[];
  onRequestSort?: (value: string, event: React.MouseEvent<HTMLButtonElement>) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  tableRow: {
    height: 47,
    fontSize: '9px',
    lineHeight: 'none'
  },
  checkBox: {
    '&&:hover': {
      backgroundColor: 'transparent'
    }
  },
  checkBoxSize: {
    fontSize: '16px'
  },
  arrowButton: {
    position: 'relative',
    left: '5%',
    top: '50%',
    color: theme.palette.grey[500]
  }
}));

const HeaderRow: FC<Props> = props => {
  const classes = useStyles();
  const { headers, onRequestSort } = props;

  const [labelSelected, setLabelSelected] = useState<string>('');

  const createSortHandler = (value: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
    setLabelSelected(value);
    onRequestSort!(value, event);
  };

  const renderContent = () => {
    return headers.map(header => {
      const countChecked = header.checked && header.checked.length;
      const totalShouldBeChecked = header.rowsPerPage && header.rowsPerPage;
      const renderCheckBoxIcon = () => {
        if (countChecked !== 0) {
          if (countChecked !== totalShouldBeChecked) {
            return <CheckBoxOutlinedUncompletedIcon className={classes.checkBoxSize} />;
          } else {
            return <CheckBoxIcon className={classes.checkBoxSize} />;
          }
        }
      };
      return (
        <HeaderCell
          key={header.label}
          pL={header.pL}
          pR={header.pR}
          pT={header.pT}
          pB={header.pB}
          bB={header.bB}
          mW={header.mW}
          verticalAlign={header.verticalAlign}
          isCheckBox={header.isCheckBox}
        >
          {header.isCheckBox ? (
            <Checkbox
              key={header.label}
              icon={<CheckBoxOutlineBlankIcon className={classes.checkBoxSize} />}
              checkedIcon={renderCheckBoxIcon()}
              edge='start'
              color='primary'
              className={classes.checkBox}
              checked={countChecked !== 0 ? true : false}
              tabIndex={-1}
              disableRipple
              onChange={header.handleCheckAll}
            />
          ) : (
            header.label
          )}
          {header.isSort && (
            <IconButton size='small' className={classes.arrowButton} onClick={createSortHandler(header.value!)}>
              {labelSelected === header.value ? (
                header.orderBy! === 'desc' ? (<ArrowDropDownIcon />) : (<ArrowDropUpIcon />)
              ) : (
                <ArrowDropDownIcon />
              )}
            </IconButton>
          )}
        </HeaderCell>
      );
    });
  };
  return <TableRow className={classes.tableRow}>{renderContent()}</TableRow>;
};

export default HeaderRow;
